import React, { useContext, useEffect, useState } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { TOP_LEVEL_NAV_ROUTES } from "../../config/NavRoutes";
import { assets } from "../../assets/assets";
import { AuthContext } from "../../contexts/AuthContext";
import { TopBarContext, TopBarProvider } from "../../contexts/TopBarContext";

import Login from "../Login/Login";
//import Register from "../Register/Register";
// import ConfirmLogin from "../Login/ConfirmLogin";
import AccountUnauthorised from "../Login/AccountUnauthorised"
import EditDisplayName from "../Settings/EditDisplayName"
import TopBar from "../../components/TopBar/TopBar";
import NavBar from "../../components/Navbar/Navbar";

import Campaigns from "../Campaigns/Campaigns";
import CampaignOverview from "../Campaigns/CampaignOverview";
import CampaignOverviewLegacy from "../Campaigns/CampaignOverview_Legacy";
import Users from "../Users/Users";
import BugReports from "../BugReport/BugReports";
import Analytics from "../Analytics/Analytics";
import Schedule from "../Schedule/Schedule";
import Settings from "../Settings/Settings";
import { CampaignProvider } from "../../contexts/CampaignContext";
import "./MainSiteContainer.scss";
import { defaultOptions } from "../../api/axios";
import CreateCampaign from "../CreateCampaign/CreateCampaign";
import CampaignSetup from "../CampaignSetup/CampaignSetup";
import { getDefautTimezone, getLocaleData, getTimezoneListData } from "../../helpers/Dates";
import ManageStream from "../Streams/ManageStream";

import { ACCOUNT_TYPES } from "../../helpers/AccountTypes";

import Feature from "../Feature/Feature";
import ClawController from "../Feature/ClawController";
import KokoDebugControls from "../Debug/KokoDebugControls";
import ClawDebugControls from "../Debug/ClawDebugTools";
import Error404 from "../Error404/Error404";
import Blank from "../BlankContainer/BlankContainer";
import CustomiseFeature from "../CustomiseFeature/CustomiseFeature";
import ColorPickerPopUp from "../../components/forms/ColorPicker/ColorPickerPopUp";
import ChangeBotStatusPopup from "../Settings/ChangeBotStatusPopup";

import TimelineEditor from "../TimelineEditor/NodeEditor";

import Quizzes from "../Quizzes/Quizzes";
import EditQuiz from "../Quizzes/EditQuiz";
import SeederEditor from "../SeederEditor/SeederEditor";
import StreamfogTest from "../StreamfogTest/StreamfogTest";
import ExpiredFeature from "../Feature/ExpiredFeature";
import ClawCameraFeed from "../ClawCameraFeed/ClawCameraFeed";
import CustomiseCampaign from "../CustomiseCampaign/CustomiseCampaign";
import VisualEditorTest from "../VisualEditorTest/VisualEditorTest";
import Home from "../Home/Home";
import Inspiration from "../Inspiration/Inspiration";
import SiteAdmin from "../SiteAdmin/SiteAdmin";
import VerticalModeTest from "../VerticalModeTest/VerticalModeTest";

const MainSiteContainer = () => {
    const [authContext, setAuthContext] = useContext(AuthContext);
    
    const [haveCheckedBotAuth, setHaveCheckedBotAuth] = useState(false);
    const [showBotAuthPop, setShowBotAuthPop] = useState(false);
    const closeBotAuthPop = () => setShowBotAuthPop(false);
    useEffect(
        () => {
            if (!haveCheckedBotAuth && authContext.isLoggedIn && authContext.userData?.isTwitchLogin && !authContext.userData?.isBotAuthorised) {
                setShowBotAuthPop(true);
                setHaveCheckedBotAuth(true);
            }
        },
        [authContext.isLoggedIn]
    )

    const location = useLocation();

    const checkIsStandaloneView = () => {
        const pathSegment = (location.pathname.split('/')[1] || '').toLowerCase();
        const clawSegment = (TOP_LEVEL_NAV_ROUTES.CLAW_CAMERA_FEED.split('/')[1] || '').toLowerCase();
        return pathSegment === clawSegment;
    }
    
    // Check if we are on a feature url!
    const featurePathSegment = (location.pathname.split('/')[1] || '').toLowerCase();
    const featureRouteSegment = (TOP_LEVEL_NAV_ROUTES.FEATURE.split('/')[1] || '').toLowerCase();
    const verticalModeTestSegment = (TOP_LEVEL_NAV_ROUTES.VERTICAL_MODE_TEST.split('/')[1] || '').toLowerCase();
    const isFeature = featurePathSegment === featureRouteSegment || featurePathSegment === verticalModeTestSegment;
    // Check if we are on a claw controller url!
    const clawControllerPathSegment = (location.pathname.split('/')[1] || '').toLowerCase();
    const clawControllerRouteSegment = (TOP_LEVEL_NAV_ROUTES.CLAW_CONTROLLER.split('/')[1] || '').toLowerCase();
    const isClawController = clawControllerPathSegment === clawControllerRouteSegment;

    const isStandaloneView = checkIsStandaloneView();

    try {
        // throw(new Error('Debugging throw'));

        // Feature routes - highest priority, render immediately
        if (!authContext.initialising && !isStandaloneView && (isFeature || isClawController)) {
            return (
                <CampaignProvider>
                    <Routes>
                        <Route path={TOP_LEVEL_NAV_ROUTES.FEATURE} element={<Feature />} />
                        <Route path={TOP_LEVEL_NAV_ROUTES.FEATURE_EXPIRED} element={<ExpiredFeature />} />
                        <Route path={TOP_LEVEL_NAV_ROUTES.VERTICAL_MODE_TEST} element={<VerticalModeTest />} />
                        <Route path={TOP_LEVEL_NAV_ROUTES.CLAW_CONTROLLER} element={<ClawController />} />
                    </Routes>
                </CampaignProvider>
            );
        }
        
        return (
            <>
                {/* Auth context is performing initial validation */}
                {authContext.initialising && 
                    <div className="initialising-container">
                        {/* We can probably do something better with this later (or maybe just leave it blank?) */}
                        <img className="glitch" alt="Twitch Glitch 3" src={assets.LoadingFeature} />
                    </div>
                }
                { !authContext.initialising && isStandaloneView &&
                    <>
                        <Routes>
                            <Route path={TOP_LEVEL_NAV_ROUTES.CLAW_CAMERA_FEED} element={<ClawCameraFeed />} />
                        </Routes>
                        <TopBar forceHideRightSide={true} />
                    </>
                }

                {/* Not logged in - only allow us to view the login and register pages */}
                {!authContext.initialising && !isStandaloneView && !authContext.isLoggedIn && !isFeature &&
                    <CampaignProvider>
                        <Routes>
                            <Route path={TOP_LEVEL_NAV_ROUTES.LOGIN} element={<Login />} />
                            {/* Shunt us off to the login page if we are logged out and not on login or register page */}
                            <Route path="*" element={<Navigate to={TOP_LEVEL_NAV_ROUTES.LOGIN} replace={true} />} />
                        </Routes>
                    </CampaignProvider>
                }

                {!isFeature && !authContext.initialising && authContext.isLoggedIn && (!authContext.isConfirmed) &&
                    <Routes>
                        <Route path={TOP_LEVEL_NAV_ROUTES.LOGIN} element={<Login openConfirmLogin="true" />} />
                        {/* Shunt us off to the confirm page if we still need to confirm and don't go to Login or Register */}
                        <Route path="*" element={<Navigate to={TOP_LEVEL_NAV_ROUTES.LOGIN} replace={true} />} />
                    </Routes>
                }
        
                {!isFeature && !authContext.initialising && authContext.isLoggedIn && (authContext.isConfirmed) && !authContext.userData.isAuthorised &&
                    <Routes>
                        <Route path={TOP_LEVEL_NAV_ROUTES.NOT_AUTHORSIED} element={<AccountUnauthorised />} />
                        <Route path="*" element={<Navigate to={TOP_LEVEL_NAV_ROUTES.NOT_AUTHORSIED} replace={true} />} />
                    </Routes>
                }

                {!isFeature && !authContext.initialising && authContext.isLoggedIn && (authContext.isConfirmed) && (!authContext.userData.firstName || authContext.userData.firstName =='') &&
                    <Routes>
                        <Route path={TOP_LEVEL_NAV_ROUTES.EDIT_DISPLAY_NAME} element={<EditDisplayName newUser={true}/>} />
                        <Route path="*" element={<Navigate to={TOP_LEVEL_NAV_ROUTES.EDIT_DISPLAY_NAME} replace={true} />} />
                    </Routes>
                }

                {/* Logged in - show persistent nav bar on the left, content on the right */}
                {!authContext.initialising && authContext.isLoggedIn && (authContext.isConfirmed) && authContext.userData.isAuthorised && !isStandaloneView && !isFeature &&
                <TopBarProvider>
                    <div className="main-site-container">
                        <div className={`${!isFeature && !isClawController ? 'under-top-bar' : 'no-top-bar'}`}>
                            {!isFeature && !isClawController &&
                                <div className="nav-pane">
                                    <NavBar></NavBar>
                                </div>
                            }
                            <div className="content-pane">
                                    <CampaignProvider>
                                        <Routes>
                                        <Route path={TOP_LEVEL_NAV_ROUTES.HOME} element={<Home />} />
                                        <Route path={'/'} element={<Navigate to={TOP_LEVEL_NAV_ROUTES.HOME} replace={true} />} />
                                        <Route path={TOP_LEVEL_NAV_ROUTES.CAMPAIGNS} element={<Campaigns />} />
                                        <Route path={TOP_LEVEL_NAV_ROUTES.CAMPAIGN_OVERVIEW_LEGACY} element={<CampaignOverviewLegacy />} />
                                        <Route path={TOP_LEVEL_NAV_ROUTES.CAMPAIGN_OVERVIEW_TAB} element={<CampaignOverview />} />
                                        <Route path={TOP_LEVEL_NAV_ROUTES.CAMPAIGN_OVERVIEW} element={<CampaignOverview />} />
                                        <Route path={TOP_LEVEL_NAV_ROUTES.CUSTOMISE_FEATURE} element={<CustomiseFeature />} />
                                        <Route path={TOP_LEVEL_NAV_ROUTES.TIMELINE_EDITOR} element={<TimelineEditor />} />
                                        <Route path={TOP_LEVEL_NAV_ROUTES.CUSTOMISE_CAMPAIGN} element={<CustomiseCampaign />} />
                                        <Route path={TOP_LEVEL_NAV_ROUTES.VISUAL_EDITOR_TEST} element={<VisualEditorTest />} />
                                        <Route path={TOP_LEVEL_NAV_ROUTES.EDIT_DISPLAY_NAME} element={<Blank />} />
                                        <Route path={TOP_LEVEL_NAV_ROUTES.CUSTOMISE_FEATURE_STREAM} element={<CustomiseFeature />} />
                                        <Route path={TOP_LEVEL_NAV_ROUTES.MANAGE_CAMPAIGN_STREAM} element={<ManageStream />} />
                                        <Route path={TOP_LEVEL_NAV_ROUTES.USERS} element={<Users />} />
                                        { authContext.userData.userLevel >= ACCOUNT_TYPES.twitchSuperUser.level &&
                                            <Route path={TOP_LEVEL_NAV_ROUTES.BUG_REPORTS} element={<BugReports />} />
                                        }
                                        <Route path={TOP_LEVEL_NAV_ROUTES.ANALYTICS} element={<Analytics />} />
                                        <Route path={TOP_LEVEL_NAV_ROUTES.SCHEDULE} element={<Schedule />} />
                                        <Route path={TOP_LEVEL_NAV_ROUTES.SETTINGS} element={<Settings />} />
                                        <Route path={TOP_LEVEL_NAV_ROUTES.CREATE_CAMPAIGN} element={<CreateCampaign />} />
                                        <Route path={TOP_LEVEL_NAV_ROUTES.CAMPAIGN_SETUP} element={<CampaignSetup />} />
                                        <Route path={TOP_LEVEL_NAV_ROUTES.QUIZZES} element={<Quizzes />} />
                                        <Route path={TOP_LEVEL_NAV_ROUTES.CREATE_QUIZ} element={<EditQuiz />} />
                                        <Route path={TOP_LEVEL_NAV_ROUTES.EDIT_QUIZ} element={<EditQuiz />} />
                                        <Route path={TOP_LEVEL_NAV_ROUTES.EDIT_CAMPAIGN_FEATURE_QUIZ} element={<EditQuiz />} />
                                        <Route path={TOP_LEVEL_NAV_ROUTES.FEATURE} element={<Feature />} />
                                        <Route path={TOP_LEVEL_NAV_ROUTES.CLAW_CONTROLLER} element={<ClawController />} />
                                        <Route path={TOP_LEVEL_NAV_ROUTES.FEATURE_EXPIRED} element={<ExpiredFeature />} />
                                        { authContext.userData.userLevel >= ACCOUNT_TYPES.twitchSuperUser.level &&
                                            <>
                                                <Route path={TOP_LEVEL_NAV_ROUTES.CLAW_DEBUG_TOOLS} element={<ClawDebugControls />} />
                                                <Route path={TOP_LEVEL_NAV_ROUTES.KOKO_DEBUG_TOOLS} element={<KokoDebugControls />} />
                                                <Route path={TOP_LEVEL_NAV_ROUTES.FEATURE_EDITOR} element={<SeederEditor />} />
                                                <Route path={TOP_LEVEL_NAV_ROUTES.SITE_ADMIN + '/*'} element={<SiteAdmin />} />
                                            </>
                                        }

                                        <Route path={TOP_LEVEL_NAV_ROUTES.STREAMFOG_TEST} element={<StreamfogTest />} />
                                        <Route path={TOP_LEVEL_NAV_ROUTES.VERTICAL_MODE_TEST} element={<VerticalModeTest />} />
                                        <Route path={TOP_LEVEL_NAV_ROUTES.INSPIRATION} element={<Inspiration />} />

                                        <Route path="*" element={<Error404 />} />
                                    </Routes>
                                </CampaignProvider>
                        </div>
                    </div>
                        {/* Had to move the top bar down here because drop shadows using filters messed up z-indexes and box-shadow doesn't play well with rounded corners */}
                        {!isFeature && !isClawController && <TopBar inCampaign={location.pathname.includes('/campaigns/')} />}
                        {!isFeature && !isClawController && <ColorPickerPopUp />}
                    </div>
                </TopBarProvider>
                }
                {showBotAuthPop &&
                    <ChangeBotStatusPopup closePanelFunc={closeBotAuthPop} />
                }
            </>
        );
    } catch (error) {
        console.error(error);
        return (
            <>
                <div className="page-error-container">
                    <div className="page-error header">
                        <h1>Oops...</h1>
                        <p>We have encountered an error.</p>
                    </div>
                    <div className="page-error">
                        <p>Please report the following error to the support team, along with as much information as you can about what you were doing when the error occurred.</p>
                        <p>ERROR MESSAGE: {error.message}</p>
                        <p>PAGE URL: {window.location.href}</p>
                    </div>
                </div>

                <div className="page-error-container">
                    <p>Once you have reported the error, refreshing the page should get you back up an running.</p>
                </div>
            </>
        );
    }
}

export default MainSiteContainer;
